// extracted by mini-css-extract-plugin
export default {"mapa":"Mapa_mapa__8Xf9p"};